import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceiptCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.83911 9.00031L6.26768 10.8217L10.5177 5.9646",
		stroke: "white",
		strokeWidth: 1.35,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.0713 1.10734H3.53563C2.89153 1.10734 2.27381 1.3632 1.81837 1.81865C1.36292 2.2741 1.10706 2.89182 1.10706 3.53591V16.8931L4.14277 15.0716L7.17848 16.8931L10.2142 15.0716L13.2499 16.8931V2.92877C13.2499 2.4457 13.4418 1.9824 13.7833 1.64082C14.1249 1.29924 14.5883 1.10734 15.0713 1.10734ZM15.0713 1.10734C15.5544 1.10734 16.0178 1.29924 16.3593 1.64082C16.7009 1.9824 16.8928 2.4457 16.8928 2.92877V7.17877H13.2499",
		stroke: "white",
		strokeWidth: 1.35,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgReceiptCheck;
